import flatten from "lodash/flatten";
import uniq from "lodash/uniq";

import { CreateRequirementDefinitionSharedFileMimeType } from "../../../../Requirements/modules/SharedFile/types";
import { MIME_TYPES_VALUES } from "../../SharedFile/createRequirementDefinition/utils";

export const mapMimeTypesToRequestFormat = (
  mimeTypes: Partial<
    Record<CreateRequirementDefinitionSharedFileMimeType, boolean>
  >
): string[] => {
  return uniq(
    flatten(
      Object.entries(mimeTypes)
        .filter(([_, value]) => value)
        .map(
          ([key, value]) =>
            MIME_TYPES_VALUES[
              key as CreateRequirementDefinitionSharedFileMimeType
            ]
        )
    )
  );
};
